import { UiItem, UiSection, DynamicUiData } from './types';
import { UseFormReturnType } from '@mantine/form';
import { FormValuesType } from './types';

function isFormEditable(
  form: UseFormReturnType<FormValuesType>,
  section: UiSection,
  uiData: DynamicUiData,
): boolean {
  if (form.isDirty()) {
    return true;
  }
  return section.children.some(item => isItemEditable(item, uiData));
}

const isItemEditable = (item: UiItem, uiData: DynamicUiData): boolean => {
  switch (item.type) {
    case 'SEPARATOR':
      return false;
    case 'FIELD':
      return true;
    case 'FIELD_ROW':
      return item.children.some(child => isItemEditable(child, uiData));
    case 'UI_ENTITY_SECTION_GROUP':
    case 'UI_GRID':
      return item.children
        .flatMap(child => (child.type === 'FIELD' ? child : child.children))
        .some(child => isItemEditable(child, uiData));
    case 'UI_ENTITY':
      return item.children.some(child => isItemEditable(child, uiData));
    case 'ENTITY_LIST': {
      const entityData = uiData.entities[item.entityType];
      if (!entityData) {
        return false;
      }
      if (Array.isArray(entityData)) {
        return entityData.length > 0;
      }
      return true;
    }
  }
};

export { isFormEditable, isItemEditable };
